export const eventData = {
  exploreProductsClick: 'explore_products_click',
  companyClick: 'company_click',
  contactClick: 'contact_click',
  linkClick: 'link_click',
  categoryClick: 'category_click',
}

export const eventCategory = {
  footerClick: 'footer_click',
}

export const eventMapping = {
  [eventData.linkClick]: {
    event: eventData.linkClick,
    eventCategory: eventCategory.footerClick,
  },
  [eventData.categoryClick]: {
    event: eventData.categoryClick,
    eventCategory: eventCategory.footerClick,
  },
  [eventData.exploreProductsClick]: {
    event: eventData.exploreProductsClick,
    eventCategory: eventCategory.footerClick,
  },
  [eventData.companyClick]: {
    event: eventData.companyClick,
    eventCategory: eventCategory.footerClick,
  },
  [eventData.contactClick]: {
    event: eventData.contactClick,
    eventCategory: eventCategory.footerClick,
  },
}
